import React, { useState } from 'react';
import cn from 'classnames';

import { LIFECYCLE_COLORS, STATUS_LABELS, DISPLAY_STATUSES, toDisplayLifecycle, fmtInt } from '../../helpers/spotlights_dashboard_helpers';
import './LifecycleBar.scss';

// A horizontal segmented bar of lifecycle status proportions, colored with the same palette as
// the Overview lifecycle donut. Hovering a segment highlights it and shows a tooltip with the
// status, count, and share. Used in the expanded brand row.
const LifecycleBar = ({ lifecycle = {} }) => {
  const [hovered, setHovered] = useState(null);

  const display = toDisplayLifecycle(lifecycle);
  const present = DISPLAY_STATUSES.filter(s => (display[s] || 0) > 0);
  const total = present.reduce((n, s) => n + display[s], 0);
  if (!total) return <div className='sl-empty' style={{ padding: 12 }}>No spotlights.</div>;

  // Pre-compute each segment's width + center offset (for tooltip positioning).
  let acc = 0;
  const segments = present.map(s => {
    const pct = (display[s] / total) * 100;
    const seg = { status: s, pct, count: display[s], center: acc + pct / 2 };
    acc += pct;
    return seg;
  });

  const active = hovered && segments.find(x => x.status === hovered);

  return (
    <div className='sl-lifecycle-bar-wrap'>
      {active && (
        <div className='sl-lifecycle-tooltip' style={{ left: `${active.center}%` }}>
          <span className='dot' style={{ background: LIFECYCLE_COLORS[active.status] }} />
          <strong>{STATUS_LABELS[active.status]}</strong> · {fmtInt(active.count)} ({Math.round(active.pct)}%)
        </div>
      )}

      <div className={cn('sl-lifecycle-bar', { 'has-hover': !!hovered })} onMouseLeave={() => setHovered(null)}>
        {segments.map(seg => (
          <div
            key={seg.status}
            className={cn('sl-lifecycle-seg', { active: hovered === seg.status })}
            style={{ width: `${seg.pct}%`, background: LIFECYCLE_COLORS[seg.status] }}
            onMouseEnter={() => setHovered(seg.status)}
          />
        ))}
      </div>

      <div className='sl-lifecycle-legend'>
        {present.map(s => (
          <div
            key={s}
            className={cn('sl-lifecycle-legend-item', { active: hovered === s, dim: hovered && hovered !== s })}
            onMouseEnter={() => setHovered(s)}
            onMouseLeave={() => setHovered(null)}
          >
            <span className='dot' style={{ background: LIFECYCLE_COLORS[s] }} />
            {STATUS_LABELS[s]} <span className='count'>{fmtInt(display[s])}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LifecycleBar;
